import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { PATHS, FULL_PATHS } from '../../../constants';

export const AllStatementsSucceeded = ({
    remove,
    input,
}: ToastRenderContentProps<
    OnGroupStoppedInput<FilenameInput, Record<string, unknown>>
>): JSX.Element => {
    const location = useLocation();
    const success = input?.success ?? [];

    const statementOrStatements =
        success.length === 1
            ? 'statement has'
            : `${success.length} statements have`;

    return (
        <div style={{ width: 410 }} className="px-2">
            <div className="font-bold text-primary-500 tracking-wider mb-2">
                Good news!
            </div>
            <div className="mb-2">
                {`Your ${statementOrStatements} been added.`}
            </div>
            {location !== undefined &&
                !location.pathname.includes(PATHS.STATEMENTS) && (
                    <div className="font-normal text-tertiary-500">
                        Go&nbsp;
                        <Link
                            to={({ search }) => ({
                                pathname: FULL_PATHS.STATEMENTS_CHARTS,
                                search,
                            })}
                        >
                            <button
                                className="text-primary-500 underline"
                                type="button"
                                onClick={(): void => {
                                    remove({
                                        canceled: false,
                                        success: true,
                                    });
                                }}
                            >
                                check them out
                            </button>
                        </Link>
                        &nbsp;when you&rsquo;re ready!
                    </div>
                )}
        </div>
    );
};
